module.exports = __webpack_public_path__ + "static/media/Img_info_8ECEE0.9fdf4106.jpg";